import { createContext, useState } from "react"
import API from "services/api"

export const UploadContext = createContext({})

const UploadProvider = (props) => {
	const [files, setFiles] = useState([])
	const [loadingUpload, setLoadingUpload] = useState(false)

	const postUploadImage = (data) => {
		return API.uploadImageBase64(data)
			.then((res) => {
				const { data } = res
				return { status: 200, data: data }
			})
			.catch((err) => {
				console.log("err", err)
				return { status: 404, data: err.message }
			})
	}

	const postUploadDocument = (data) => {
		setLoadingUpload(true)
		return API.uploadDocumentBase64(data)
			.then((res) => {
				const { data } = res
				setLoadingUpload(false)
				return { status: 200, data: data }
			})
			.catch((err) => {
				setLoadingUpload(false)
				// console.log("err", err)
				// return { status: 404, data: err.message }
				throw err
			})
	}

	const postConvertPdfToImg = (data) => {
		return API.postConvertPdfToImg(data)
			.then((res) => {
				const { data } = res
				return { status: 200, data: data }
			})
			.catch((err) => {
				console.log("err", err)
				return { status: 404, data: err.message }
			})
	}

	const postConvertPdfToImgByID = (data) => {
		return API.postConvertPdfToImgByID(data)
			.then((res) => {
				const { data } = res
				return { status: 200, data: data }
			})
			.catch((err) => {
				console.log("err", err)
				return { status: 404, data: err.message }
			})
	}

	return (
		<UploadContext.Provider
			value={{
				postUploadImage,
				postUploadDocument,
				postConvertPdfToImg,
				postConvertPdfToImgByID,

				files,
				setFiles,
				loadingUpload,
				setLoadingUpload
			}}
			{...props}
		/>
	)
}

export default UploadProvider
